<script setup lang="ts">
import { computed, ref } from 'vue';

import { LoanType } from '@/helpers/const';
import { useUserQuoteProcess } from '@/helpers/useUserQuoteProcess';

import ScenarioTypeTabs from './modules/ScenarioTypeTabs.vue';

import type { LoanTypeEnum } from '@/types';

const { loanApp, startStateType, state, updateAllSectionStates, saveAndGoNext, goBack } = useUserQuoteProcess();

const triedToContinue = ref(false);
const selectedLoanType = ref<LoanTypeEnum | undefined>(loanApp.value.loanType || LoanType.BRIDGING);

const showError = computed(() => triedToContinue.value && !startStateType.value);

const startQuote = () => {
  if (!startStateType.value) {
    triedToContinue.value = true;
    return;
  }

  if (!selectedLoanType.value) return;

  const incomingProperties = selectedLoanType.value === LoanType.EQUITY_RELEASE ? [] : loanApp.value.incomingProperties;

  updateAllSectionStates(startStateType.value);

  saveAndGoNext({ loanType: selectedLoanType.value, incomingProperties });
};
</script>

<template>
  <div class="mb-4 pb-2">
    <h2 class="text-2xl font-medium">
      How much
      <BxHighlight>detail</BxHighlight>
      would you like to provide?
    </h2>
  </div>
  <BxExpander>
    <template #header>
      <div class="my-2 md:m-2">
        <div class="pb-2 md:p-4">
          <ScenarioTypeTabs :show-error="showError" />
        </div>
        <div class="flex md:px-6 md:pb-4">
          <span class="hidden pt-1 sm:inline"><BxIcon name="warning" aria-hidden="true" /></span>
          <div class="pl-2 md:pl-4">
            <h2 class="text-base font-medium leading-6 text-gray-900 md:text-lg">
              Select Simple or Comprehensive mode.
            </h2>
            <p class="text-sm md:text-base">
              This sets the default level of detail for your scenario — you can still toggle individual sections later
              as you go.
            </p>
          </div>
        </div>
      </div>
    </template>
  </BxExpander>
  <div class="mt-6">
    <BxButton id="quote-start" variant="primary" @click="startQuote">Continue</BxButton>
    <BxButton v-if="state.nextEvents.includes('BACK')" variant="link" class="ml-4" @click="goBack()"> Back </BxButton>
  </div>
</template>
